import { createSlice } from '@reduxjs/toolkit';

type InitialState = {
  type: string;
  plan: number;
  members: number | null,
  plans: any | null,
}

const initialState: InitialState = {
  type: '',
  plan: 1,
  members: null,
  plans: null,
};

const planSlice = createSlice({
  name: 'selected plan',
  initialState,
  reducers: {
    setSelectedPlan: (state, { payload }) => {
      const { type, plan, members }: { type: string, plan: number, members: number | null } = payload;

      state.type = type;
      state.plan = plan;
      state.members = members;
    },
    setSelectedPlanId: (state, { payload }) => {
      const { id }: { id: number} = payload;

      state.plan = id;
    },
    setMembers: (state, { payload }) => {
      state.members = payload;
    },
    setPlans: (state, { payload }) => {
      state.plans = payload;
    }
  },
});

export const { setSelectedPlan, setSelectedPlanId, setMembers, setPlans } = planSlice.actions;

export default planSlice.reducer;
